(function () {
  function clean(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  function getTitleEl() {
    return document.getElementById('ProductTitle');
  }

  function getBaseTitle(titleEl) {
    return titleEl.getAttribute('data-base-title') || clean(titleEl.textContent);
  }

  // GLO swatches: Option 1 (Print) is typically the first swatch group on the product page.
  function getSelectedPrintFromGLO() {
    const root = document.querySelector('.globo-swatch-product-detail');
    if (!root) return '';

    // Find the FIRST option block, then find the checked input inside it
    // (GLO commonly renders option blocks as repeated containers)
    const optionBlocks = root.querySelectorAll('.globo-swatch-product-detail-item, .swatch, .globo-swatch, .product-swatch');
    const firstBlock = optionBlocks && optionBlocks.length ? optionBlocks[0] : root;

    const checked = firstBlock.querySelector('input:checked');
    if (checked) return clean(checked.value || checked.getAttribute('value'));

    return '';
  }

  // Fallback if GLO structure is different: use the first checked input on the page that belongs to GLO
  function getSelectedPrintFallback() {
    const checked = document.querySelector('.globo-swatch-product-detail input:checked');
    if (checked) return clean(checked.value || checked.getAttribute('value'));
    return '';
  }

  function updateTitle() {
    const titleEl = getTitleEl();
    if (!titleEl) return;

    const baseTitle = getBaseTitle(titleEl);

    const print = getSelectedPrintFromGLO() || getSelectedPrintFallback();

    // If we can't detect print yet, don't break anything
    if (!print) {
      titleEl.textContent = baseTitle;
      return;
    }

    titleEl.textContent = `${print} – ${baseTitle}`;
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', updateTitle);

  // Re-run on interactions (GLO updates selection on click)
  document.addEventListener('click', function () { setTimeout(updateTitle, 0); });
  document.addEventListener('change', function () { setTimeout(updateTitle, 0); });

  // Re-run shortly after load in case swatches render late
  setTimeout(updateTitle, 300);
})();
